import List from '@utils/list'
const { Jurisdiction, Table } = List
import options from './config/options'

const jurisdiction = new Jurisdiction()
  .lib('add').to('Performance.Rate.Add')
  .lib('modify').modify('Performance.Rate.Modify')
  .lib('delete').del('/srmPerformanceLevel/deleteSrmPerformanceLevelByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('performance.rate')
  .add('levelName')
  .add('topScore')
  .add('bottomScore')
  .add('remarks')
  .add('performanceStrategy').op(options)

export default new List()
  .url('/srmPerformanceLevel/getSrmPerformanceLevelPageByParams', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .table(table)
  .end()
